<template>
  <jw-radio-group class="xl-search-group" v-model="selectVal" :default-value="defVal" @change="changeSelect">
    <template v-if="subcol.card">
      <jw-radio :value="item.value" v-for="item in options" :key="item.value">
        <template #radio="{ checked }">
          <jw-space class="jw-custom-card" :class="{ 'jw-custom-card-checked': checked }">
            <template v-if="item?.icon">
              <component :is="item?.icon" />
            </template>
            <template v-else-if="item?.pic">
              <img class="jw-custom-card-pic" :src="item?.pic" />
            </template>
            {{ item.label }}
          </jw-space>
        </template>
      </jw-radio>
    </template>
    <template v-else>
      <jw-radio :value="item.value" v-for="item in options" :key="item.value">{{ item.label }}</jw-radio>
    </template>
  </jw-radio-group>
</template>

<script setup>
// import { reactive, toRefs } from 'vue';
import { ref, computed, watchEffect } from 'vue';
const props = defineProps({
  subcol: {
    type: Object,
    default() {
      return {};
    }
  }
});
const emits = defineEmits(['cb']);
const selectVal = ref(props.subcol.value !== undefined ? props.subcol.value : '');
const defVal = computed(() => (props.subcol.value !== undefined ? props.subcol.value : ''));
const options = ref(props.subcol.data || []);

watchEffect(() => {
  options.value = props.subcol.data || [];
  selectVal.value = props.subcol.value;
});
// select 事件
const changeSelect = (v) => {
  const o = {};
  console.log(33, v);
  let pv = v;
  if (pv.length === 0) pv = undefined;
  o[props.subcol.name] = pv;
  emits('cb', o);
};
</script>
<style scoped lang="less">
@import './xl-radio.less';
</style>
